
<ngx-loading-bar
  height="4px"
  color="#856aae"
  [includeSpinner]="false"></ngx-loading-bar>
<router-outlet></router-outlet>
<app-error></app-error>
